// extracted by mini-css-extract-plugin
export default {"button-style":"UploadButton_button-style__ZrVke","hover-text":"UploadButton_hover-text__Iq4ps","wrapper":"UploadButton_wrapper__2+bLc"};